import React, { useState } from "react";
import { Button, Container, Center } from "@chakra-ui/react";


import { ChatList } from "../Chat/components/listChat";

export default function Chat() {

    return (
        <Container maxW="xxl" mt={100}>
            <ChatList />
        </Container>
    );
}
